import React, { useContext, useState, useEffect } from 'react'
import { getImages } from '../const'
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import ValidationError from '../Errors/ValidationError';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-time-picker/dist/TimePicker.css';
import ReCAPTCHA from 'react-google-recaptcha';
import { VehicleContext } from '../Context/VehicleContext';
import { Link, useNavigate } from 'react-router-dom';

const ScheduleServiceModal = ({ close }) => {
    const {submitContactForm, vehicleListSearch, vehicleDecode, validateVIN} = useContext(VehicleContext);
    const recaptchaRef = React.useRef();
    const navigate = useNavigate();
    
    const [date, setDate] = useState(null);
    const generateTimes = () => {
        const times = [];
        let currentTime = new Date();
        currentTime.setHours(8, 0, 0);
        
        const endTime = new Date();
        endTime.setHours(17, 0, 0); 
        
        while (currentTime <= endTime) {
            const formattedTime = currentTime.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
            });
            times.push(formattedTime);
            currentTime.setMinutes(currentTime.getMinutes() + 30); // Increment by 30 minutes
        }
        return times;
    }
    const timeList = generateTimes();
    
    const validationSchema = Yup.object().shape({
        service: Yup.string().required('Service is required'),
        preferred_date: Yup.date().required('Preferred date is required'),
        preferred_time: Yup.string().required('Preferred time is required'),
        year: Yup.string().required('Year is required'),
        make: Yup.string().required('Make is required'),
        model: Yup.string().required('Model is required'),
        mileage: Yup.string().required('Mileage is required'),
        full_name: Yup.string().required('Full name is required'),
        email: Yup.string().email('Invalid email').required('Email is required'),
        phone: Yup.string().required('Phone number is required'),
        //marketing_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information'),
        //marketing_info_agreement: Yup.bool().oneOf([true], 'Terms must be agreed to in order to submit your information')
    });

    const serviceTypes = ['Oil Change','Fuel Filter','Spark Plugs','Transmission','Brake Inspection','Air Filter','Timing Belt','Wheel Alignment','Cooling System','Shocks','Tire Rotation','Other'];

    const formikRef = React.useRef();

    const [vinData,setVinData] = useState(null);

    const onChangeVin = (e) => {

        if(validateVIN(e.target.value)) {
            getVINData(e.target.value);
        } 
        
        formikRef.current.setFieldValue('vin',e.target.value);
    }

    const getVINData = async (vin) => {
        const response = await vehicleDecode(vin);

        if('attributes' in response) {
            setVinData(response.attributes);

            formikRef.current.setFieldValue('year',response.attributes.Year);

            var data = await getVehicleYearData(response.attributes.Year);

            formikRef.current.setFieldValue('make',response.attributes.Make);

            var data = await getVehicleModels(response.attributes.Year,response.attributes.Make);

            formikRef.current.setFieldValue('model',response.attributes.Model);

        }
    }

    const [vehicleYears,setVehicleYears] = useState([]);
    const [vehicleMakes,setVehicleMakes] = useState([]);
    const [vehicleModels,setVehicleModels] = useState([]);

    const [vehicleYearData,setVehicleYearData] = useState([]);

    useEffect(() => {

        if(!vehicleYears || vehicleYears.length === 0) {

            getVehicleYears();
        }  
    },[]);

    const getVehicleYears = async () => {
        const data = await vehicleListSearch({'subject':'year'});
        console.log(data);
        setVehicleYears(data);
    }

    const getVehicleYearData = async (year) => {
        const data = await vehicleListSearch({'subject':'yeardata','year':year});
        console.log(data);

        setVehicleYearData(data);
        
        let makes = [];
        
        if('makes' in data) {
            data['makes'].map((make,i) => {
                makes.push(make.name);
            });

            setVehicleMakes(makes);
        }
    }

    const getVehicleModels = async (year,make) => {        
        console.log(year,make);

        if('makes' in vehicleYearData) {

            let models = [];

            vehicleYearData['makes'].filter((item) => item.name == make).map((make,i) => {
                console.log(make);
                if('models' in make) {
                    make['models'].map((model,j) => {
                        models.push(model.name);
                    })
                }
            });

            setVehicleModels(models);
        }
    }

    return (
        <>
            <div className="modal-content">
                <div className="modal-body ss-pd">
                    <button className="sm-box-close" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                    <div className='xs-title font-1-9em text-lgray text-uppercase mb-4'>Schedule Service</div>
                    <Formik
                        validationSchema={validationSchema}
                        innerRef={formikRef}
                        initialValues={{
                            service: '',
                            preferred_date: '',
                            preferred_time: '',
                            year: '',
                            make: '',
                            model: '',
                            mileage: '',
                            vin: '',
                            full_name: '',
                            email: '',
                            phone: '',
                            comment: '',
                            service_form: true,
                            marketing_agreement: false,
                            marketing_info_agreement: false
                        }}
                        onSubmit={async (values, { resetForm }) => {
                            const token = await recaptchaRef.current.executeAsync();
                            recaptchaRef.current.reset(); // Reset after use

                            values.token = token;

                            console.log(values);
                            const data = await submitContactForm(values);
                            close();

                            if (data.success) {
                                resetForm();
                                navigate("/thank-you");
                                // alert("Thank you for your submission. We'll be in touch soon!");
                            } else
                                alert("There was a problem with your submission");
                        }}
                    >
                        {({ values, setFieldValue, field, form }) => (
                             <Form className="custom-form schedule-form row" autoComplete="off">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey="6Ld25IorAAAAANZCaPfhdftOf511aOBscsnhKulz" // Replace with your actual site key
                                    size="invisible"
                                />
                             <Field type="hidden" name="service_form" value="true" />
                             <div className='col-md-6'>
                                 <div className='form-group'>
                                     <div className='cs-label mb-0'>Select Service</div>
                                     <Field as="select" name="service" className="form-control">
                                         <option value="">Select</option>
                                         {serviceTypes.map((v,i) => (
                                            <option key={i} value={v}>{v}</option>
                                         ))}
                                     </Field>
                                     <ValidationError name="service" />
                                 </div>
                             </div>
 
                             <div className='col-md-6'>
                                 <div className='row gx-4'>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                             <div className='cs-label mb-0'>Preferred Date</div>
                                             <DatePicker
                                                 selected={date}
                                                 onChange={(val) => {
                                                     setDate(val);
                                                     setFieldValue('preferred_date', val);
                                                 }}
                                                 className="form-control w-100"
                                                 dateFormat="MM-dd-yyyy"
                                                 placeholderText="mm/dd/yy"
                                             />
                                             <ValidationError name="preferred_date" />
                                         </div>
                                     </div>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                             <div className='cs-label mb-0'>Preferred Time</div>
                                             <Field as="select" name="preferred_time" className="form-control">
                                                 <option value=''>Select</option>
                                                 {timeList.map((time, index) => (
                                                     <option key={index} value={time}>
                                                         {time}
                                                     </option>
                                                 ))}
                                             </Field>
                                             <ValidationError name="preferred_time" />
                                         </div>
                                     </div>
                                 </div>
                             </div>
 
                             <div className='col-12'><hr className='cs-hr' /></div>
 
                             <div className='col-md-6'>
                                 <div className='row gx-4'>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                             <div className='cs-label mb-0'>Vehicle Year</div>
                                             <Field as="select" name="year" className="form-control"
                                                onChange={(e) => { setFieldValue('year',e.target.value); getVehicleYearData(e.target.value); }}
                                            >
                                                 <option value="">Select</option>
                                                 {vehicleYears.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                             </Field>
                                             <ValidationError name="year" />
                                         </div>
                                     </div>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                            <div className='cs-label mb-0'>Make</div>
                                            <Field as="select" name="make" className="form-control"
                                                onChange={(e) => { setFieldValue('make',e.target.value); getVehicleModels(values.year,e.target.value); }} 
                                            >
                                                 <option value="">Select</option>
                                                 {vehicleMakes.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                             </Field>
                                             <ValidationError name="make" />
                                         </div>
                                     </div>
                                 </div>
                             </div>
 
                             <div className='col-md-6'>
                                 <div className='row gx-4'>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                             <div className='cs-label mb-0'>Model</div>
                                             <Field as="select" name="model" className="form-control">
                                                 <option value="">Select</option>
                                                 {vehicleModels.map((v, i) => (
                                                    <option key={i} value={v}>
                                                        {v}
                                                    </option>
                                                ))}
                                             </Field>
                                             <ValidationError name="model" />
                                         </div>
                                     </div>
                                     <div className='col-md-6'>
                                         <div className='form-group'>
                                             <div className='cs-label mb-0'>Mileage</div>
                                             <Field type="text" name="mileage" className="form-control" />
                                             <ValidationError name="mileage" />
                                         </div>
                                     </div>
                                 </div>
                             </div>
 
                             <div className='col-12'>
                                 <div className='form-group'>
                                     <div className='cs-label mb-0'>VIN</div>
                                     <Field type="text" name="vin" className="form-control" onChange={onChangeVin}/>
                                 </div>
                             </div>
 
                             <div className='col-12'><hr className='cs-hr' /></div>
 
                             <div className='col-md-6'>
                                 <div className='form-group'>
                                     <div className='d-flex align-items-center justify-content-between mb-1'>
                                         <div className='cs-label mb-0'>Full Name</div>
                                         <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                     </div>
                                     <Field type="text" name="full_name" className="form-control" />
                                     <ValidationError name="full_name" />
                                 </div>
                                 <div className='form-group'>
                                     <div className='d-flex align-items-center justify-content-between mb-1'>
                                         <div className='cs-label mb-0'>Email</div>
                                         <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                     </div>
                                     <Field type="text" name="email" className="form-control" />
                                     <ValidationError name="email" />
                                 </div>
                                 <div className='form-group'>
                                     <div className='d-flex align-items-center justify-content-between mb-1'>
                                         <div className='cs-label mb-0'>Phone Number</div>
                                         <div className='text-required'><span className='text-orange'>*</span> Required</div>
                                     </div>
                                     <Field type="text" name="phone" className="form-control" />
                                     <ValidationError name="phone" />
                                 </div>
                             </div>
 
                             <div className='col-md-6'>
                                 <div className='form-group'>
                                     <div className='cs-label mb-1'>Comments</div>
                                     <Field
                                         name="comment"
                                         className="form-control h-202"
                                         as="textarea"
                                     />
                                     <ValidationError name="comment" />
                                 </div>
                             </div>
                            <div className="col-12 wow reveal fadeInUp">
                                <div className='form-group marketing-agree'>
                                    <div className="custom-checkbox fin_app_chkbox">
                                        <Field
                                            type="checkbox"
                                            name="marketing_agreement"
                                            // value="agree" 
                                            id="iAgreeChk"
                                        />
                                        <label htmlFor="iAgreeChk"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive marketing/promotional SMS messages from McLaren Orlando, including special offers, exclusive incentives, event invitations, and dealership news.</label>
                                    </div>
                                    <ValidationError name="marketing_agreement"/>
                                </div>
                                <div className="form-group marketing-agree">
                                    <div className="custom-checkbox fin_app_chkbox">
                                        <Field
                                            type="checkbox"
                                            name="marketing_info_agreement"
                                            // value="agree" 
                                            id="iAgreeChk2"
                                        />
                                        <label htmlFor="iAgreeChk2"  className="cs-label fw-400 font-12 pt-1">Yes, I agree to receive informational/transactional SMS messages from McLaren Orlando, such as appointment reminders, service updates, vehicle status notifications, and important account-related information.</label>
                                    </div>
                                    <ValidationError name="marketing_info_agreement"/>
                                </div>
                                <div className="form-group">
                                    <div className="custom-checkbox fin_app_chkbox mb-4">
                                        <div  className="cs-label fw-400 font-12 pt-1 custom-breadcrumb">By providing your mobile number and checking the above box/es, you agree to related text messages from McLaren Orlando at the phone number you provided when signing up. Reply STOP to unsubscribe, Reply HELP for help. Message frequency varies. Message & data rates may apply. Consent is not a condition of purchase. For more information, please review our Privacy Policy <Link to="https://cars.mclaren.com/us_en/privacy-policy">Privacy Policy</Link> and <Link to="https://cars.mclaren.com/us_en/terms-conditions">Terms of Service</Link></div>
                                    </div>
                                </div>
                            </div>
                            <div className='text-end mt-4'>
                                <button type='submit' className='theme-btn text-uppercase d-inline-block'>
                                    Schedule Service
                                </button>
                            </div>
                         </Form>
                     )}
                    </Formik>
                </div>
            </div>
        </>
    )
}

export default ScheduleServiceModal